//
//
//
//
//
//
//
//
//

export default {
  name: 'breadcrumbs',

  props: {
    divider: {
      type: String,
      default: '/'
    },

    icons: Boolean
  },

  computed: {
    classes () {
      return {
        'breadcrumbs--with-icons': this.icons
      }
    }
  },

  mounted () {
    this.$vuetify.load(this.init)
  },

  methods: {
    init () {
      this.$children.forEach(i => (i.$el.dataset.divider = this.divider))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/breadcrumbs/Breadcrumbs.vue